import each from 'lodash/each';
import find from 'lodash/find';

export const state = {
  campaigns: [],
  categories: null,
  productTypes: null,
  maxPages: null,
  defaultSort: 'age:desc',
  search: null,
  searchApplied: false,
  selectedSort: 'age:desc',
  selectedProductType: '0',
  selectedCategory: null,
  sortOptions: [
    { value: 'Newest First', key: 'age:desc' },
    { value: 'Lowest Price First', key: 'price:asc' },
    { value: 'Highest Price First', key: 'price:desc' },
  ],
  showMobileFilterModal: false,
  showMobileSortModal: false,
};

export const mutations = {
  setSelectedSort(state, sort) {
    let selectedSortObj = find(state.sortOptions, option => option.value === sort);

    if (selectedSortObj) {
      state.selectedSort = selectedSortObj.key;
    } else {
      state.selectedSort = state.defaultSort;
    }
  },

  resetMarketplaceFilters(state) {
    state.search = null;
    state.searchApplied = false;
    state.selectedSort = state.defaultSort;
    state.selectedProductType = '0';
    state.selectedParentCategory = 'ALL';
    state.selectedSubCategory = 'ALL';
  },
};